import {
  Button,
  Descriptions,
  Drawer,
  Form,
  Input,
  Modal,
  Select,
  Space,
  Table,
  Tooltip,
  Typography,
  Upload,
} from "antd";
import axios from "axios";
import React, { useContext, useState } from "react";
import { NotificationInfo } from "../../../context";
import {
  DeleteOutlined,
  EditOutlined,
  MinusCircleOutlined,
  PlusCircleOutlined,
  CheckOutlined,
} from "@ant-design/icons";

const CustomerViewOrders = ({
  open,
  close,
  //   setLoading,
  getAllExistingOrder,
  orderList,
  totalCost,
}) => {
  const { rerunNotif } = useContext(NotificationInfo);
  const [loadings, setLoadings] = useState(false);
  const scroll = {};
  const tableLayout = "";
  const [openConfirmDiag, setOpenConfirmDiag] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const tranxID = localStorage.getItem("tranxID");
  const [dialogData, setDialogData] = useState(null);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [count, setCount] = useState(1);
  const [editDialog, setEditDialog] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");
  const [fileList, setFileList] = useState([{}]);

  const tableProps = {
    bordered: false,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const columns = [
    {
      title: "Product",
      // dataIndex: "product",
      sorter: (a, b) => a.product - b.product,
      render: (text, record) => <p>{text.product}</p>,
    },
    {
      title: "Description",
      // dataIndex: "description",
      sorter: (a, b) => a.description - b.description,
      render: (text, record) => <p>{text.description}</p>,
    },
    {
      title: "Price x Qty",
      align: "right",
      render: (text, record) => (
        <p style={{ width: 80 }}>
          &#8369;{text.price} x {text.quantity}
        </p>
      ),
    },
    {
      title: "Amount",
      align: "right",
      render: (text, record) => (
        <p>
          &#8369;
          {parseFloat(
            parseFloat(text.price) * parseFloat(text.quantity)
          ).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </p>
      ),
    },
    {
      title: "",
      dataIndex: "",
      align: "center",
      render: (text) => (
        <p style={{ width: 80 }}>
          <Tooltip title="Edit">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setDialogData(text);
                setCount(parseInt(text.quantity));
                setEditDialog(true);
              }}
              icon={<EditOutlined />}
              style={{ marginRight: 10 }}
            />
          </Tooltip>
          <Tooltip title="Delete">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setDialogData(text);
                setDeleteDialog(true);
              }}
              icon={<DeleteOutlined />}
            />
          </Tooltip>
        </p>
      ),
    },
  ];

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const handleConfirmOrders = (values) => {
    const formdata = new FormData();
    formdata.append("transaction_id", tranxID);
    formdata.append("image", values.file === undefined ? "" : values.file.file);
    for (const name in values) {
      formdata.append(name, values[name]);
    }
    setLoadings(true);
    // setLoading(true);
    axios
      .post("customer/confirm-all-orders", formdata)
      .then((response) => {
        const data = response.data;
        // console.log("DATA", data)
        if (data === "success") {
          rerunNotif("success", "Confirm all orders successfully.");
          setTimeout(() => {
            close();
            setLoadings(false);
            // setLoading(false);
            getAllExistingOrder();
            localStorage.setItem(
              "tranxID",
              Math.floor(Math.random() * 99999999) + 1
            );
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  const handleOk = () => {
    setConfirmLoading(true);
    setTimeout(() => {
      setDeleteDialog(false);
      setConfirmLoading(false);
      handleDeleteProductInOrder();
    }, 2000);
  };

  const handleDeleteProductInOrder = () => {
    const formdata = new FormData();
    formdata.append("id", dialogData !== null ? dialogData.id : "");
    formdata.append("transaction_id", tranxID);
    setLoadings(true);
    axios
      .post("customer/delete-product-in-order", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Delete product successfully.");
          setTimeout(() => {
            if (orderList.length === 1) {
              close();
              setLoadings(false);
              getAllExistingOrder();
            } else {
              setLoadings(false);
              getAllExistingOrder();
            }
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  const handleEditQtyProduct = () => {
    const formdata = new FormData();
    formdata.append("id", dialogData !== null ? dialogData.id : "");
    formdata.append("transaction_id", tranxID);
    formdata.append("quantity", count);
    setLoadings(true);
    axios
      .post("customer/edit-product-in-order", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Updated product successfully.");
          setTimeout(() => {
            setEditDialog(false);
            setLoadings(false);
            getAllExistingOrder();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  const handleChange = (info) => {
    // console.log(info);
    let fileList = [...info.fileList];
    fileList = fileList.slice(-1);
    // console.log("fileList", fileList);
    setFileList(fileList);
  };

  return (
    <Drawer
      title="Order List"
      width={window.innerWidth > 500 ? 600 : "100vw"}
      //   style={{ width: window.innerWidth > 600 ? 720 : "auto" }}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
    >
      <div style={{ overflowX: "auto" }}>
        <Table
          {...tableProps}
          pagination={false}
          columns={tableColumns}
          dataSource={orderList.length > 0 ? orderList : []}
          scroll={scroll}
          rowKey={(record) => record.id}
          size={window.innerWidth > 575 ? "large" : "small"}
        />
        <div style={{ display: "flex", padding: 15 }}>
          <div style={{ flexGrow: 1 }} />
          <Typography style={{ fontWeight: "bold", fontSize: 18 }}>
            Total: &#8369;
            {totalCost.toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </Typography>
        </div>
      </div>

      {orderList.length > 0 && (
        <Button
          type="primary"
          loading={loadings}
          style={{ width: "100%", borderRadius: "20px" }}
          onClick={() => setOpenConfirmDiag(true)}
        >
          {loadings ? "Loading" : "Confirm"}
        </Button>
      )}

      <Modal
        title="Confirm orders"
        open={openConfirmDiag}
        onCancel={() => setOpenConfirmDiag(false)}
        footer={null}
      >
        <Form
          layout="vertical"
          name="basic"
          initialValues={{ remember: true }}
          onFinish={handleConfirmOrders}
          autoComplete="off"
        >
          <Space direction="vertical" style={{ width: "100%", margin: 0 }}>
            <Form.Item
              name="payment_method"
              label="Payment Method"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <Select
                placeholder="-"
                onChange={(e) => {
                  // console.log("E", e);
                  setSelectedPaymentMethod(e);
                }}
                size="large"
                showSearch
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                <Select.Option value={"cash"}>Cash</Select.Option>
                <Select.Option value={"ecash"}>E-Cash</Select.Option>
              </Select>
            </Form.Item>

            {selectedPaymentMethod === "ecash" && (
              <Form.Item
                name="file"
                rules={[
                  {
                    required: true,
                    message: "Product image required",
                  },
                ]}
              >
                <Upload
                  beforeUpload={({ fileList: newFileList }) => {
                    // setFileList(newFileList);
                    return false;
                  }}
                  onChange={handleChange}
                  multiple={false}
                  listType="picture-card"
                  maxCount={1}
                  // defaultFileList={[]}
                  showUploadList={{
                    showRemoveIcon: false,
                  }}
                  fileList={fileList}
                >
                  {/* <Button icon={<UploadOutlined />}>Click to Upload</Button> */}
                  Upload
                </Upload>
              </Form.Item>
            )}

            <Form.Item
              name="customer_name"
              label="Customer Name"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <Input placeholder="Set Customer Name" size="large" />
            </Form.Item>

            <Form.Item
              name="service_category"
              label="Category"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <Select
                placeholder="Select category"
                onChange={(value) => setSelectedCategory(value)}
                showSearch
                size="large"
              >
                <Select.Option value={"takeout"}>Take Out</Select.Option>
                <Select.Option value={"dine"}>Dine</Select.Option>
              </Select>
            </Form.Item>

            {selectedCategory === "dine" && (
              <Form.Item
                name="table_no"
                label="Table Number"
                rules={[
                  {
                    required: true,
                    message: "Required",
                  },
                ]}
              >
                <Input placeholder="Set Table Number" size="large" />
              </Form.Item>
            )}
          </Space>

          <Form.Item style={{ marginTop: "20px" }}>
            <Button
              type="primary"
              loading={loadings}
              htmlType="submit"
              style={{ width: "100%", borderRadius: "20px" }}
            >
              {loadings ? "Loading" : "Confirm"}
            </Button>
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        title="Are you sure to delete this product?"
        open={deleteDialog}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={() => setDeleteDialog(false)}
      />

      <Modal
        title=""
        open={editDialog}
        onCancel={() => setEditDialog(false)}
        footer={null}
        // width={350}
      >
        {dialogData !== null && (
          <>
            <Descriptions title="Product Info" column={1}>
              <Descriptions.Item
                label="Product"
                contentStyle={{
                  fontWeight: "bold",
                }}
              >
                {dialogData.product}
              </Descriptions.Item>
              <Descriptions.Item
                label="Description"
                contentStyle={{
                  fontWeight: "bold",
                }}
              >
                {dialogData.description}
              </Descriptions.Item>
              <Descriptions.Item
                label="Price"
                contentStyle={{
                  fontWeight: "bold",
                }}
              >
                &#8369;{dialogData.price}
              </Descriptions.Item>
            </Descriptions>
            <div
              style={{
                border: "1px solid #e5e5e5",
                marginTop: 10,
                marginBottom: 10,
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Button
                  type="dashed"
                  shape="circle"
                  onClick={() => {
                    setCount(count - 1);
                  }}
                  icon={<MinusCircleOutlined />}
                  disabled={count === 1 ? true : false}
                />
                <Typography.Title
                  level={4}
                  style={{ marginLeft: 10, marginRight: 10, marginTop: 10 }}
                >
                  {/* {console.log("count", count)} */}
                  {count}
                </Typography.Title>
                <Button
                  type="dashed"
                  shape="circle"
                  onClick={() => {
                    setCount(count + 1);
                  }}
                  icon={<PlusCircleOutlined />}
                  // disabled={count === 1 ? true : false}
                />
              </div>
            </div>

            <div>
              <Button
                type="primary"
                //   shape="circle"
                onClick={handleEditQtyProduct}
                icon={<CheckOutlined />}
                // disabled={count === 1 ? true : false}
                style={{ width: "100%" }}
              >
                Update
              </Button>
            </div>
          </>
        )}
      </Modal>
    </Drawer>
  );
};

export default CustomerViewOrders;
